import { useState } from "react";
import {
  Input,
  FormLabel,
  FormControl,
  InputRightElement,
  InputGroup,
  Image,
  Text,
} from "@chakra-ui/react";
import { useField } from "formik";

const TextInput = ({
  label,
  name = "",
  placeholder,
  isPassword,
  type,
  labelColor,
  labelSize,
  icon,
  disabled = false,
  unit,
  min,
  max,
}) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [field, meta] = useField(name);

  const inputType = type
    ? type
    : !isPassword
    ? "text"
    : isPasswordShown
    ? "text"
    : "password";

  return (
    <FormControl>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : 12}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          {...field}
          type={inputType}
          placeholder={placeholder}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={"12px"}
          lineHeight={"20"}
          color={"#000000"}
          height={"48px"}
          _placeholder={{ color: "#898989" }}
          isDisabled={disabled}
          pr={unit || isPassword || icon ? "3rem" : "1rem"} // Add space for right element
          min={min} // apply min
          max={max} // apply max
        />
        {(unit || icon || isPassword) && (
          <InputRightElement height="100%" pointerEvents="none">
            <Text
              color="#898989"
              fontSize="12px"
              lineHeight="20px"
              fontFamily={"PlusJakartaSansRegular"}
              mr="8px"
            >
              {unit}
            </Text>
          </InputRightElement>
        )}
        {icon && <InputRightElement>{icon}</InputRightElement>}
        {isPassword && (
          <InputRightElement
            onClick={() => setIsPasswordShown((p) => !p)}
            height={"48px"}
          >
            {isPasswordShown ? (
              <Image src={require("assets/svgs/eye-crossed.svg").default} />
            ) : (
              <Image src={require("assets/svgs/eye.svg").default} />
            )}
          </InputRightElement>
        )}
      </InputGroup>
      {meta && meta.touched && meta.error ? (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily={"PlusJakartaSansRegular"}
          lineHeight={"20px"}
          //   mt={1}
        >
          {meta.error}
        </Text>
      ) : null}
    </FormControl>
  );
};

export default TextInput;
